import React from 'react';

import { cn } from 'lib/helpers/utility';

import TagPill from '../../TagPill/TagPill';

const WrappedView = ({ tags, label, className }) => (
  <div className={cn('min-w-0', className)}>
    {label && <label className="mb-1 block text-sm text-neutral-900">{label}</label>}
    <ul className="m-0 flex min-w-0 list-none flex-wrap gap-1.5 p-0" data-qa="tags-wrapped">
      {tags?.map((tag, index) => (
        <li key={tag?.id ?? index} className="flex min-w-0 max-w-full">
          <TagPill tag={tag} wrap />
        </li>
      ))}
    </ul>
  </div>
);

export default WrappedView;
